import { getLocales } from 'assets/locales/Locale';
import { formatFormPhone } from 'assets/utils/forms/formatFormPhone';
import PayeeType from 'models/claims/payeeType/Model.PayeeType';
import { usePublicCreateClaimProvider } from '../Hooks';
import { LocationSearch } from 'assets/templates/locationSearch/LocationSearch';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';

export function PublicCreateClaimNewRepairFacility() {
  const { lang } = getLocales();
  const publicCreateClaim = usePublicCreateClaimProvider();
  const payeeData = publicCreateClaim.form.data?.newPayee;
  const payeeErrors = publicCreateClaim.form.errors?.newPayee;

  function updatePayee(payee: Utils.FormData<Model.IPayee>) {
    publicCreateClaim.form.merge({ newPayee: { ...payee, payeeTypeId: PayeeType.REPAIR_FACILITY_ID } });
    publicCreateClaim.form.merge({
      claim: { createdByPayee: { email: payee.email, phoneNumber: payee.phoneNumber, name: payee.name } },
    });
  }

  return (
    <>
      <InputWrapper>
        <LocationSearch
          onSelect={(location) => {
            updatePayee({
              streetAddress: location?.Line1 || null,
              provinceCode: location?.ProvinceCode || null,
              city: location?.City || null,
              countryCode: location?.CountryIso3 || null,
              postalCode: location?.PostalCode || null,
            });
          }}
        />
        <div style={{ width: '100%' }} />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          name="streetAddress"
          label={lang.streetAddress}
          error={payeeErrors?.streetAddress}
          value={payeeData?.streetAddress ?? ''}
          onChange={updatePayee}
        />
        <TextInput
          name="city"
          label={lang.city}
          error={payeeErrors?.city}
          value={payeeData?.city ?? ''}
          onChange={updatePayee}
        />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          name="postalCode"
          label={lang.postalCode}
          error={payeeErrors?.postalCode}
          value={payeeData?.postalCode ?? ''}
          onChange={updatePayee}
        />
        <TextInput
          name="countryCode"
          label={lang.countryCode}
          error={payeeErrors?.countryCode}
          value={payeeData?.countryCode ?? ''}
          onChange={updatePayee}
        />
        <TextInput
          name="provinceCode"
          label={lang.provinceCode}
          error={payeeErrors?.provinceCode}
          value={payeeData?.provinceCode ?? ''}
          onChange={updatePayee}
          uppercase
        />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          name="name"
          label={lang.name}
          error={payeeErrors?.name}
          value={payeeData?.name ?? ''}
          onChange={updatePayee}
        />
        <TextInput
          name="phoneNumber"
          label={lang.phoneNumber}
          error={payeeErrors?.phoneNumber}
          value={payeeData?.phoneNumber ?? ''}
          onChange={({ phoneNumber }) => {
            updatePayee({
              phoneNumber: formatFormPhone(payeeData?.phoneNumber, phoneNumber),
            });
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          name="email"
          label={lang.email}
          error={payeeErrors?.email}
          value={payeeData?.email ?? ''}
          onChange={updatePayee}
        />
        <div style={{ width: '100%' }} />
      </InputWrapper>
    </>
  );
}
